import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { FormattedMessage } from 'translate';

const TxDate = ({ isMobile, transactionDate }) => (
  <div className={clsx('block', { mobile: isMobile, right: !isMobile })}>
    <span className="row-title">
      <FormattedMessage id="main.date" />
    </span>
    <span className="row-info">{moment(transactionDate).format('MMM D, YYYY HH:mmA')}</span>
  </div>
);

TxDate.propTypes = {
  isMobile: PropTypes.bool,
  transactionDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TxDate;
